export const fileStates = {
   M: {state: 'modified', color: 'var(--theme-primary)', disabled: false},
   // A: {state: 'active', color: '#ff9800', disabled: false},
   C: {state: 'cleaned', color: '#66bb6a', disabled: true},
   R: {state: 'rejected', color: '#f44336', disabled: true},
   '': {state: 'free', color: '#c1c1c1', disabled: false}
}
